<template>
    <div class="form-group">
        <label :for="id">{{ label }}</label>
        <input
            type="text"
            :id="id"
            :value="value"
            @input="$emit('change', $event.target.value)"
            :name="name"
            :placeholder="placeholder"
            :required="required"
            :disabled="disabled"
        />
    </div>
</template>

<script>
export default {
    name: 'TextInput',

    props: {
        label: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            required: true,
        },

        value: {
            required: true,
        },

        name: {
            type: String,
        },

        placeholder: {
            type: String,
            default: '',
        },


        required: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    input {
        flex: 6;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;

        &:disabled {
            background-color: darken(#fff, 5%);
            cursor: not-allowed;
        }
    }
}
</style>
